// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"94b88fe0","513":"93abfd8b","703":"e8b28898"}[chunkId] + ".chunk.js";
};